const CaptionType = {
  Insight: 'insight',
  Quiz: 'quiz',
  Trending: 'trending',
  Privacy: 'privacy',
  Inspire: 'inspire'
};

export default CaptionType;
